import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public loggedIn = false;

  public setLoggedIn = new BehaviorSubject<boolean>(this.loggedIn);
  castLoggedIn = this.setLoggedIn.asObservable();

  isAuthenticated() {
    const promise = new Promise(
      (resolve, reject) => {
        setTimeout( () => {
          resolve(this.loggedIn);
        }, 200);
      }
    );
    return promise;
  }
  login(value: boolean) {
    this.loggedIn = value;
    if (value === true) {
      localStorage.setItem('IsUserLogin', '1');
      this.setLoggedIn.next(value);
    } else {
      localStorage.setItem('IsUserLogin', '0');
      this.setLoggedIn.next(value);
    }
  }
  logout() {
    sessionStorage.clear();
    this.loggedIn = false;
    localStorage.setItem('IsUserLogin', '0');
    localStorage.clear();
    this.setLoggedIn.next(this.loggedIn);
  }
  constructor() {
    const getUserLoginStatus = localStorage.getItem('IsUserLogin');
    if (getUserLoginStatus === '1' && getUserLoginStatus !== null ) {
      this.loggedIn = true;
    } else {
      this.loggedIn = false;
    }
    this.setLoggedIn.next(this.loggedIn);
  }
}
